<template>
  <footer class="footer-responsive align-center" :class="{ 'is-international': isInternational }">
    <div class="row-1">
      <nav class="nav-footer-wrapper grid-container padding-top-l padding-bottom-l" aria-label="Primary footer section">
        <FooterLinksCommon />
        <FooterStayConnectedMcom class="stay-connected" />
      </nav>
    </div>
    <div class="row-2">
      <nav class="grid-container padding-top-m padding-bottom-m" aria-label="Secondary footer section">
        <FooterPrivacyLinksCommon :links="legalLinks" />
        <FooterCopyrightCommon />
      </nav>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';
import { GET_LEGAL_LINKS } from '#shared/types/getters';

const pageData = usePageData();
const navFooter = useNavFooter();
const isInternational = computed(() => pageData.navigation.context.isInternational);
const legalLinks = computed(() => navFooter?.[GET_LEGAL_LINKS]);
</script>

<style lang="scss" brand="mcom" scoped>
@import '~/assets/scss/variables.mcom.scss';
@import '~/assets/scss/mixins.mcom.scss';

.footer-responsive {
  .stay-connected {
    margin-left: auto;
  }

  &.is-international {
    .row-1 {
      .nav-footer-wrapper {
        gap: map-get($grid-margin-gutters, 'large');

        @include breakpoint(large up) {
          .stay-connected {
            flex-grow: 1;
            flex-basis: 0;
          }
        }

        @include breakpoint(mlarge up) {
          .stay-connected {
            flex-grow: 1;
            flex-basis: 0;
          }
        }
      }
    }
  }

  .row-1 {
    background-color: $footer-background-color;

    @include breakpoint(large up) {
      .nav-footer-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        gap: map-get($grid-margin-gutters, 'medium');

        .stay-connected {
          flex-basis: 317px;
        }

        :deep() {
          .footer-links-group {
            flex-grow: 1;
            flex-basis: 0;
          }
        }
      }
    }

    @include breakpoint(mlarge up) {
      .nav-footer-wrapper {
        gap: map-get($grid-margin-gutters, 'large');
        .stay-connected {
          flex-basis: 464px;
        }
      }
    }
  }

  .row-2 {
    background-color: $black;
  }
}
</style>
